import { createContext, useContext } from 'react';

const SpotlightContext = createContext({ register: () => {}, unregister: () => {} });

export const useSpotlightContext = () => useContext(SpotlightContext);

export default SpotlightContext;
